import React from "react";
import DetailUnit from "./DetailUnit";

// Halaman detail unit versi internal: me-render komponen DetailUnit yang sama
// dengan flag `internal` sehingga blocker "Unit Tidak Tersedia" untuk lelang
// lampau dilewati (akses tetap dibatasi login via authList), namun halaman
// selalu di-noindex agar tidak terindeks mesin pencari.
export default function DetailUnitInternal() {
  return <DetailUnit internal />;
}
